import {
    CardPointeThirdPartySystemId,
    CloverThirdPartySystemId,
    type MerchantConfig,
    type ThirdPartySystemId,
} from '@anchorbase/pillar-sdk';
import { ValorThirdPartySystemId } from '@anchorbase/pillar-sdk/ipg/valor/system-constants';
import type { CredentialFieldDefaults } from '../credential-defaults';
import { resolveCardPointeCredentialDefaults } from './cardpointe/cardpointe-credential-defaults';
import { resolveCloverCredentialDefaults } from './clover/clover-credential-defaults';
import { resolveValorCredentialDefaults } from './valor/valor-credential-defaults';

type IpgCredentialDefaultsResolver = (
    merchantConfig: MerchantConfig | undefined
) => CredentialFieldDefaults;

const IpgCredentialDefaultsResolvers: ReadonlyMap<
    ThirdPartySystemId,
    IpgCredentialDefaultsResolver
> = new Map([
    [
        CardPointeThirdPartySystemId,
        () => resolveCardPointeCredentialDefaults(),
    ],
    [
        CloverThirdPartySystemId,
        () => resolveCloverCredentialDefaults(),
    ],
    [
        ValorThirdPartySystemId,
        (merchantConfig: MerchantConfig | undefined) =>
            resolveValorCredentialDefaults(merchantConfig),
    ],
]);

export function resolveIpgCredentialDefaultsBySystemId(
    systemId: ThirdPartySystemId,
    merchantConfig: MerchantConfig | undefined
): CredentialFieldDefaults {
    const resolver: IpgCredentialDefaultsResolver | undefined =
        IpgCredentialDefaultsResolvers.get(systemId);
    return resolver === undefined ? {} : resolver(merchantConfig);
}
